import React, { useState } from 'react';

import { Tooltip, Fab } from "@mui/material";
import Grid from '@mui/material/Grid2';
import {
  DeleteForever,
} from "@mui/icons-material";

import { 
  AbilityEffect,
  Potence, RollPlusUpgradable,
} from "@dndModels";
import { CHARACTER_LEVELS } from "@dndModels/Constants";

import SelectStringBox from "@components/input/selects/SelectStringBox";
import StringBox from "@components/input/strings/StringBox";
import SelectObjectBox from "@components/input/selects/SelectObjectBoxSimple";
import SuggestionStringBox from "@dndComponents/select/SuggestionStringBox";
import RollPlusUpgradableInput from "@dndComponents/other/RollPlusUpgradableInput";

interface Props {
  effect: AbilityEffect;
  obj: Potence;
  onChange: (changed: Potence) => void;
  onEffectChange: (changed: AbilityEffect) => void;
  onDelete: () => void;
  disabled?: boolean;
}

export default function AbilityPotenceCreateItemInput({ 
  effect,
  obj,
  onChange,
  onEffectChange,
  onDelete,
  disabled = false
}: Props) {
  const [ping, setPing] = useState(false);

  return (
    <Grid container spacing={0} direction="row">
      <Grid
        size={{
          xs: 2
        }}>
        { !disabled &&
          <Tooltip title={`Delete Potence`}>
            <Fab size="small" color="primary" style={{marginLeft: "8px"}}
              onClick={ () => {
                onDelete();
              }}>
              <DeleteForever/>
            </Fab>
          </Tooltip>
        }
      </Grid>
      <Grid
        size={{
          xs: 2
        }}>
        <SelectStringBox 
          name="Level"
          options={CHARACTER_LEVELS}
          value={`${obj.level}`} 
          disabled={disabled}
          onChange={(changed: string) => {
            const new_obj = obj;
            new_obj.level = +changed;
            onChange(new_obj);
            setPing(!ping);
          }}
        />
      </Grid>
      <Grid
        size={{
          xs: 4
        }}>
        <SelectStringBox 
          name="Item Creation Type"
          options={["Specific","Knowledge","Selectable"]}
          value={ obj.create_item.item_creation_type }
          disabled={disabled}
          onChange={(changed: "Specific" | "Knowledge" | "Selectable") => {
            const new_obj = obj;
            new_obj.create_item.item_creation_type = changed;
            onChange(new_obj);
            setPing(!ping);
          }}
        /> 
      </Grid>
      <Grid
        size={{
          xs: 4
        }}>
        { obj.create_item.item_creation_type === "Specific" ?
          <SelectObjectBox 
            name="Item Created"
            data_type="item"
            values={ obj.create_item.base_item_ids }
            disabled={disabled}
            multiple
            onChange={(changed: string[]) => {
              const new_obj = obj;
              new_obj.create_item.base_item_ids = changed;
              onChange(new_obj);
              setPing(!ping);
            }}
          /> 
        : obj.create_item.item_creation_type === "Selectable" ?
          <StringBox 
            name="Selectable Key"
            value={effect.selectable_key} 
            disabled={disabled}
            onBlur={(changed: string) => {
              const new_obj = effect;
              new_obj.selectable_key = changed;
              onEffectChange(new_obj);
            }}
          />
        :
          <StringBox
            name="Knowledge Key" 
            value={obj.create_item.knowledge_key}
            disabled={disabled}
            onChange={(changed: string) => {
              const new_obj = obj;
              new_obj.create_item.knowledge_key = changed;
              onChange(new_obj);
              setPing(!ping);
            }}
          />
        } 
      </Grid>
      { obj.create_item.item_creation_type === "Knowledge" &&
        <Grid
          size={{
            xs: 12
          }}>
          <SuggestionStringBox 
            name="Required Tags" 
            field="tags"
            values={obj.create_item.required_tags}
            multiple
            onChange={(changed: string[]) => {
              const new_obj = obj;
              new_obj.create_item.required_tags = changed;
              onChange(new_obj);
              setPing(!ping);
            }}
          />
        </Grid>
      }
      <Grid
        size={{
          xs: 2
        }}>
        <SelectStringBox 
          name="Create at Level"
          options={CHARACTER_LEVELS}
          value={`${obj.create_item.create_at_level}`} 
          disabled={disabled}
          onChange={(changed: string) => {
            const new_obj = obj;
            new_obj.create_item.create_at_level = +changed;
            onChange(new_obj);
            setPing(!ping);
          }}
        />
      </Grid>
      <Grid
        size={{
          xs: 10
        }}>
        <RollPlusUpgradableInput 
          obj={obj.create_item.amount}
          disabled={disabled} 
          onChange={(changed: RollPlusUpgradable) => {
            const new_obj = obj;
            new_obj.create_item.amount.copy(changed);
            onChange(new_obj);
            setPing(!ping);
          }}
        />
      </Grid>
    </Grid>
  );
}
